import {DefaultNameValidation} from "../../configs/constants";
import * as yup from "yup";

export const SubscriberInputSchema = (t) => yup.object({
  name: DefaultNameValidation().required().max(255).label(t('subscriber_name')),
  email: yup.string().required().label(t('subscriber_email')),
  phone_no: yup.string().required().label(t('subscriber_phone')),
  status: yup.boolean().label(t("subscriber_status")).default(false)
});